module.exports = __webpack_public_path__ + "img/backgroundImage.b448539c.svg";